/// <amd-module name="Analytics/Boards/BurndownQueries/BurndownDataContract" />

/** Provides a breakdown of work effort, optionally per date*/
export interface WorkItemEffort {
    WorkItemType: string;
    Date: string;
    StateCategory: string;
    AggregatedEffort: number;
    State: string
}

/**
 * Wire and Client type representing aggregate work effort as of right now.
 */
export interface CurrentWorkItemAggregateEffort {
    StateCategory: string;
    AggregatedEffort: number;
    State: string;
}
